import { FeatureContext } from '@monash/portal-frontend-common';
import { WidgetContext } from '@/components/providers/WidgetProvider';
import { useContext } from 'react';

// This hook converts any additionalActions that are functions
// and calls them with featureFlags. This is a work around to allow
// us to use featureFlags within additionalOptions in each widget module
export const useAdditionalActions = (additionalActions) => {
  const { featureFlags } = useContext(FeatureContext);
  const { setEditActiveWidget } = useContext(WidgetContext);

  if (typeof additionalActions !== 'function') {
    return additionalActions;
  }

  return additionalActions({ featureFlags, setEditActiveWidget });
};
